var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8526_3468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81079 7.84867C1.81079 7.84867 3.59839 3.67761 7.76945 3.67761C11.9405 3.67761 13.7281 7.84867 13.7281 7.84867C13.7281 7.84867 11.9405 12.0197 7.76945 12.0197C3.59839 12.0197 1.81079 7.84867 1.81079 7.84867Z",
    stroke: "#555555",
    strokeWidth: 1.19173,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76929 9.63538C8.75655 9.63538 9.55688 8.83504 9.55688 7.84778C9.55688 6.86052 8.75655 6.06018 7.76929 6.06018C6.78202 6.06018 5.98169 6.86052 5.98169 7.84778C5.98169 8.83504 6.78202 9.63538 7.76929 9.63538Z",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 0.715039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8526_3468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3008,
    height: 14.3008,
    fill: "white",
    transform: "translate(0.619629 0.698608)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.3a02ecd1cc3b98f12230c47e9904f534.svg";
export { ForwardRef as ReactComponent };